import ContractInformation from './contract-information';

export default ContractInformation;